import { useState } from "react";
import { Box, Flex, Group, NavLink, Paper, Text, Title } from "@mantine/core";
import {
  IconBrandPocket,
  IconClock,
  IconHelp,
  IconLetterCase,
  IconLocation,
  IconNotes,
  IconTrash,
  IconUser,
} from "@tabler/icons-react";
import DeleteAccountModal from "@/components/Profile/DeleteAccountModal";
import AudioRetention from "@/components/Settings/AudioRetention";
import ChangeLocation from "@/components/Settings/ChangeLocation";
import Referral from "@/components/Settings/Referral";
import UsePatientImages from "@/components/Settings/UsePatientImages";
import UserDefaultNormal from "@/components/Settings/UserDefaultNormal";
import Profile from "./Profile";

const Settings = () => {
  const SECTIONS = {
    PROFILE: "PROFILE",
    REFERRAL: "REFERRAL",
    CHANGE_LOCATION: "CHANGE_LOCATION",
    AUDIO_RETENTION: "AUDIO_RETENTION",
    USE_PATIENT_IMAGES: "USE_PATIENT_IMAGES",
    USER_DEFAULT_NORMAL: "USER_DEFAULT_NORMAL",
  };
  const [sectionActive, setSectionActive] = useState<string>(SECTIONS.PROFILE);
  const isActive = (sectionName: string) => sectionActive == sectionName;
  const [openedDeleteAccountModal, setOpenedDeleteAccountModal] =
    useState<boolean>(false);
  return (
    <Box
      style={{
        maxHeight: "100%",
        padding: "10px",
      }}
    >
      <Group
        className="header-patients"
        flex={1}
        align="center"
        w={"100%"}
        justify="space-between"
      >
        <Flex align={"center"}>
          <Title size={"h3"} className="p-0 m-0">
            Settings
          </Title>
        </Flex>
      </Group>
      <Flex mt={"sm"} className="box-setting">
        <Flex
          className="box-nav"
          w={"250px"}
          direction={"column"}
          justify={"space-between"}
        >
          <Paper withBorder shadow="xs" p={0} radius={"sm"}>
            <Flex direction="column" flex={1} ta={"left"}>
              <Text
                p={5}
                fz={"16"}
                bg={"var(--mantine-color-gray-3)"}
                fw={"bold"}
              >
                Account
              </Text>
              <NavLink
                fw={500}
                leftSection={<IconUser size="16" stroke={1.5} />}
                label={"Profile"}
                onClick={() => setSectionActive(SECTIONS.PROFILE)}
                active={isActive(SECTIONS.PROFILE)}
              ></NavLink>
              <NavLink
                fw={500}
                leftSection={<IconLocation size="16" stroke={1.5} />}
                label={"Change location"}
                onClick={() => setSectionActive(SECTIONS.CHANGE_LOCATION)}
                active={isActive(SECTIONS.CHANGE_LOCATION)}
              ></NavLink>
              <NavLink
                fw={500}
                leftSection={<IconClock size="16" stroke={1.5} />}
                label={"Audio retention"}
                onClick={() => setSectionActive(SECTIONS.AUDIO_RETENTION)}
                active={isActive(SECTIONS.AUDIO_RETENTION)}
              ></NavLink>
              <NavLink
                fw={500}
                leftSection={<IconLetterCase size="16" stroke={1.5} />}
                label={"Default normals"}
                onClick={() => setSectionActive(SECTIONS.USER_DEFAULT_NORMAL)}
                active={isActive(SECTIONS.USER_DEFAULT_NORMAL)}
              ></NavLink>
              <UsePatientImages />
            </Flex>
          </Paper>
          <Paper withBorder shadow="xs" p={0} radius={"sm"} mt={20}>
            <Flex direction="column" flex={1} ta={"left"}>
              <Text
                p={5}
                fw={"bold"}
                fz={"16"}
                bg={"var(--mantine-color-gray-3)"}
              >
                Help Docs
              </Text>
              <NavLink
                leftSection={<IconHelp size="16" stroke={1.5} />}
                label="Help Docs Home"
                onClick={() =>
                  window.open("https://help.manta.app/en", "_blank")
                }
              ></NavLink>
              <NavLink
                leftSection={<IconHelp size="16" stroke={1.5} />}
                label="Custom Templates Guide"
                onClick={() =>
                  window.open(
                    "https://manta.notion.site/Manta-Classic-Templates-Unlimited-Customization-for-Your-Clinic-a7bbbe772e0344099cf27dfc7781d27c",
                    "_blank",
                  )
                }
              ></NavLink>
            </Flex>
          </Paper>
          <Paper withBorder shadow="xs" p={0} radius={"sm"} mt={20}>
            <Flex direction="column" flex={1} ta={"left"}>
              <Text
                p={5}
                fw={"bold"}
                fz={"16"}
                bg={"var(--mantine-color-gray-3)"}
              >
                Legal
              </Text>
              <NavLink
                leftSection={<IconNotes size="16" stroke={1.5} />}
                label="Terms of Use"
                onClick={() =>
                  window.open("https://manta.app/legal/terms-of-use", "_blank")
                }
              ></NavLink>
              <NavLink
                leftSection={<IconBrandPocket size="16" stroke={1.5} />}
                label="Privacy Policy"
                onClick={() =>
                  window.open("https://manta.app/legal/privacy", "_blank")
                }
              ></NavLink>
            </Flex>
          </Paper>
          <Paper withBorder shadow="xs" p={0} radius={"sm"} mt={20}>
            <Flex direction="column" flex={1} ta={"left"}>
              <Text
                p={5}
                fz={"16"}
                fw={"bold"}
                bg={"var(--mantine-color-gray-3)"}
              >
                Other
              </Text>
              <NavLink
                color="red"
                className="nav-delete-account"
                label="Delete account"
                leftSection={<IconTrash stroke={1.5} size="16" />}
                onClick={() => setOpenedDeleteAccountModal(true)}
              ></NavLink>
            </Flex>
          </Paper>
        </Flex>

        <Box className="box-content" ml={40} flex={1} h={"100%"}>
          <Paper withBorder shadow="xs" p={0} radius={"sm"} mih={"330px"}>
            {isActive(SECTIONS.PROFILE) && <Profile />}
            {isActive(SECTIONS.REFERRAL) && <Referral />}
            {isActive(SECTIONS.CHANGE_LOCATION) && <ChangeLocation />}
            {isActive(SECTIONS.AUDIO_RETENTION) && <AudioRetention />}
            {isActive(SECTIONS.USER_DEFAULT_NORMAL) && <UserDefaultNormal />}
          </Paper>
        </Box>
      </Flex>
      <DeleteAccountModal
        modalOpened={openedDeleteAccountModal}
        setModalOpened={setOpenedDeleteAccountModal}
      />
    </Box>
  );
};
export default Settings;
